<template>
  <div data-ui-section="video-list">
    <VideoCollectionVideoInitialIndexDataProvider
      :video="video"
      :video-collection-implementation="videoCollectionImplementationData"
    >
      <template slot-scope="{ isLoading, data: initialVideoIndex }">
        <div
          v-if="isLoading"
          class="p-4 text-center"
        >
          Loading video data...
        </div>
        <VsListRenderer
          v-else-if="initialVideoIndex >= 0"
          class="video-collection-list-renderer h-100"
          :initial-item-index="initialVideoIndex"
          :item-height="64.25"
          :item-fetcher="itemFetcher"
        >
          <template
            slot-scope="{ item: videoCollectionVideo, itemIndex }"
          >
            <VideoCollectionVideoPresenter
              v-if="videoCollectionVideo"
              :playing="videoCollectionVideo.id === video.id"
              :index="itemIndex"

              :video-collection-video="videoCollectionVideo"
              @click="handleDrawerItemClick"
            />
            <VideoCollectionVideoPlaceholderPresenter
              v-else
              :index="itemIndex"
            />
          </template>
        </VsListRenderer>
      </template>
    </VideoCollectionVideoInitialIndexDataProvider>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { Model, Request } from '@viddsee/server-api-client';
import VsListRenderer from '@/scripts/Components/Molecules/VsListRenderer.ts.vue';
import VideoCollectionVideoInitialIndexDataProvider from '@/scripts/pages/video/VideoCollectionDrawer/VideoCollectionVideoInitialIndexDataProvider';
import VideoCollectionVideoPresenter from '@/scripts/pages/video/VideoCollectionDrawer/VideoCollectionVideoPresenter.vue';
import VideoCollectionVideoPlaceholderPresenter from '@/scripts/pages/video/VideoCollectionDrawer/VideoCollectionVideoPlaceholderPresenter.vue';
import { VideoCollectionVideo } from '@/scripts/models/VideoCollectionVideo';
import { CollectionImplementationData } from '@/scripts/models/videoCollections/implementations/core/BaseCollectionImplementation';

export default Vue.extend({
  components: {
    VsListRenderer,
    VideoCollectionVideoInitialIndexDataProvider,
    VideoCollectionVideoPresenter,
    VideoCollectionVideoPlaceholderPresenter,
  },
  props: {
    video: {
      type: Object as PropType<Model.Video.Info>,
      required: true,
    },
    videoCollectionInfo: {
      type: Object as PropType<Model.VideoCollection.Info>,
      required: true,
    },
    videoCollectionImplementationData: {
      type: Object as PropType<CollectionImplementationData>,
      required: true,
    },
  },
  methods: {
    async itemFetcher({ perPage, page }: Request.Pagination.Options): Promise<Model.Pagination.PaginatedItemsResponse<any>> {
      const videoCollectionImplementationDataFetchers = this.videoCollectionImplementationData.fetchers;
      if (!videoCollectionImplementationDataFetchers) {
        return {
          page: 0,
          perPage: 0,
          pageCount: 0,
          itemCount: 0,
          items: [],
        };
      }

      const response = await videoCollectionImplementationDataFetchers.videos({
        perPage,
        page,
      });

      return {
        ...response,
        items: response.items.map(this.videoCollectionImplementationData.transformers.video),
      };
    },

    handleDrawerItemClick(videoCollectionVideo: VideoCollectionVideo): void {
      this.$emit('select-new-video', {
        videoCollectionVideo,
        collectionInfo: this.videoCollectionInfo,
        collectionImplementation: this.videoCollectionImplementationData,
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.video-collection-list-renderer {
  @media (min-width: 544px) {
    $drawer-bg-color: rgba(black, 0.4);
    $drawer-scroll-color: rgba(white, 0.6);

    // Add default styling for this scrollbar
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      box-shadow: none;
    }
    &::-webkit-scrollbar-thumb {
      background-color: $drawer-scroll-color;
      outline: 1px solid $drawer-bg-color;
    }
  }
}
</style>
